// extracted by mini-css-extract-plugin
export default {"captchaDialog":"COBXtQ","blockingLayer":"V3DdXc","dialog":"bRckdt","wrapper":"gT3Ogd","xButton":"AOoodt","content":"whxosc","title":"xYlb7P","subtitle":"iMXJli"};